import {Lightbox} from '../../classes/Lightbox';

export const initCards = () => {

	const components = document.querySelectorAll( 'section.cds2-cards' );

	if ( components.length ) {

		components.forEach( ( component ) => {

			const cardList = component.querySelector( 'ul.cards' );
			const cards = cardList.children;

			const openTooltip = ( evt ) => {
				if ( evt.target.closest( 'li.form' ) )
				{
					return;
				}
				
				const content = evt.target.closest( 'li' ).querySelector( 'div.content' );

				if ( window.innerWidth < 1024 ) {
					if ( !!content.querySelector( 'p' ))
					{
						Lightbox.open( content, null, 'tooltip' );
					}
				}
			}

			cards.forEach( ( card ) => {
				card.addEventListener( 'click', openTooltip );
			});
		});
	}
}
